import { render } from "./announcementTwo.vue?vue&type=template&id=f384fc12"
import script from "./announcementTwo.vue?vue&type=script&lang=js"
export * from "./announcementTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__